import PropTypes from 'prop-types';

import { Box, Typography } from '@mui/material';

import StyledTextField from '../Shared/StyledTextField';

const NumberFieldComponent = (props) => {
  const {
    input,
    meta: { touched, error },
    disabled,
    textBefore,
    textAfter,
    ...custom
  } = props;
  return (
    <Box display="flex" alignItems="center">
      {textBefore && <Typography>{textBefore}</Typography>}
      <Box mx={1}>
        <StyledTextField
          type="number"
          helperText={touched && error}
          error={touched && !!error}
          disabled={!!disabled}
          style={{ width: '4.5rem' }}
          variant="standard"
          inputProps={{
            style: { textAlign: 'center' },
          }}
          {...input}
          {...custom}
        />
      </Box>

      {textAfter && <Typography>{textAfter}</Typography>}
    </Box>
  );
};

NumberFieldComponent.propTypes = {
  input: PropTypes.instanceOf(Object).isRequired,
  meta: PropTypes.instanceOf(Object).isRequired,
  disabled: PropTypes.bool,
  textBefore: PropTypes.string,
  textAfter: PropTypes.string,
};

export default NumberFieldComponent;
